import { jsx as _jsx } from "react/jsx-runtime";
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { buildFilteredHighlightedProducts } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { getMerchCardsToShow } from '../../../constants/merchCards/MerchCardsToShow';
import Screens from '../../../constants/routing/Screens';
import { useFeatureStore } from '../../../hooks/useFeatureStore';
import SuiteFeatureTable from '../../feature-table/suite-feature-table/SuiteFeatureTable';

const PersonalizedSuiteStarterFeatureTableContainer = () => {
  const productLevels = getMerchCardsToShow({
    isFreeToStarter: true
  });
  const marketingHighlightedProducts = buildFilteredHighlightedProducts({
    productLine: MARKETING,
    productLevels
  });
  useFeatureStore({
    highlightedProducts: marketingHighlightedProducts,
    productLine: MARKETING
  });
  const salesHighlightedProducts = buildFilteredHighlightedProducts({
    productLevels,
    productLine: SALES
  });
  useFeatureStore({
    highlightedProducts: salesHighlightedProducts,
    productLine: SALES
  });
  const serviceHighlightedProducts = buildFilteredHighlightedProducts({
    productLevels,
    productLine: SERVICE
  });
  useFeatureStore({
    highlightedProducts: serviceHighlightedProducts,
    productLine: SERVICE
  });
  const operationsHighlightedProducts = buildFilteredHighlightedProducts({
    productLevels,
    productLine: OPERATIONS
  });
  useFeatureStore({
    highlightedProducts: operationsHighlightedProducts,
    productLine: OPERATIONS
  });
  const cmsHighlightedProducts = buildFilteredHighlightedProducts({
    productLevels,
    productLine: CMS
  });
  useFeatureStore({
    highlightedProducts: cmsHighlightedProducts,
    productLine: CMS
  });
  const productsByProductLine = {
    [MARKETING]: marketingHighlightedProducts,
    [SALES]: salesHighlightedProducts,
    [SERVICE]: serviceHighlightedProducts,
    [OPERATIONS]: operationsHighlightedProducts,
    [CMS]: cmsHighlightedProducts
  };
  return /*#__PURE__*/_jsx(SuiteFeatureTable, {
    productsByProductLine: productsByProductLine,
    screen: Screens.SUITE_STARTER,
    isFreeToStarter: true
  });
};

export default PersonalizedSuiteStarterFeatureTableContainer;